


































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import AudienceListingDetail from '@ui/AudienceListing/AudienceListingDetail'
import MiniCalendar from '@ui/Calendar/MiniCalendar'
import SyncIndicator from '@components/SyncIndicator'
import AudienceListingConfirmedDatesModal from '@ui/AudienceListing/AudienceListingConfirmedDatesModal'

settings =
  name: 'AudienceListingShow'

  resources:
    audience_listing:
      resourceName: 'audience_listing'
      slug: 'audience_listings/:audienceListingId'

  vue:
    components: {
      LoadingIndicator,
      AudienceListingDetail,
      MiniCalendar,
      SyncIndicator,
      AudienceListingConfirmedDatesModal,
    }

    data: ->
      confirmedDatesModal:
        show: false

    mounted: ->
      @initializeConfirmedDatesModal()

    computed:
      actionsForAudienceListingDetail: ->
        addSuperNote: @addSuperNote

      optionsForCalendar: ->
        selectable: false
        initialDate: new Date(@audience_listing.availability_windows?[0]?.date) || new Date()
        dayCellClassNames: @dayCellClassNames

      displaySyncIndicator: ->
        @audience_listing?.marked_for_sync || @audience_listing?.marked_as_syncing

    methods:
      initializeConfirmedDatesModal: ->
        @confirmedDatesModal.show = @$route.hash is '#confirmDates'

      hiOpenConfirmedDatesModal: ->
        { params, query } = @$route
        @$router.replace { params, query, hash: '#confirmDates' }
      closeConfirmedDatesModal: ->
        @$router.replace { hash: null }

      addSuperNote: (newSuperNote) ->
        @triggerResource 'audience_listing', 'add_super_note', { note: newSuperNote }

      dayCellClassNames: ({ date, isPast, ...args }) ->
        classes = []

        if @currentMemberIsSuperUser()
          confirmedDate = @audience_listing.confirmed_dates?.find((confimedDate) -> dayjs(confimedDate.date).isSame(dayjs(date)))
          classes.push 'confirmed' if !@isListingInCart and confirmedDate?.status is 'confirmed'

        classes.push 'disabled' unless classes.length
        classes

    watch:
      '$route.hash': (newHash) ->
        @confirmedDatesModal.show = newHash is '#confirmDates'

export default VueOptions.vue settings
